import client from "../httpClient";
import uiStore from "../../store/UiStore";

const deviceManagementService = {
  AddDeviceTags: () => {
    return client.Put("fleetManagement", ["fleetManagement"], {}, {});
  },
  GetDevices: () => {
    const  response =  client.Get(
      "fleetManagement",
      ["fleetManagement"],
      {},
      { staleTime: 6000 * 30 , cacheTime: 0}
    );
    if (response.isSuccess) {

      return {
        ...response,


      };
    } else {

      return { ...response, data: [] };
    }
  },
  ping: (system_id: any) => {
    const isDrawerOpen = uiStore.getUpdatesDrawerOpen();

    return client.Get(
      "ping",
      ["ping", system_id],
      { system_id },
      {
        staleTime: 0,
        cacheTime: 0,
        enabled: !isDrawerOpen,
        refetchInterval: isDrawerOpen ? false : 60000,
      }
    );
  },
};

export default deviceManagementService;
